import { createFileRoute } from '@tanstack/react-router';

import { MobilityCreate } from '@/module/Author/Mobility/MobilityCreate';

export const Route = createFileRoute('/_auth/author/_author/mobility/_mobility/create')({
  component: RouteComponent,
  staticData: {
    pageTitle: { id: 'pageTitle.create' },
  },
});

function RouteComponent() {
  return <MobilityCreate />;
}
